import { System } from 'src/app/@framework/core/clms.fw.dotnet';
import * as Domain from '../Domain';
import * as Common from '../../@framework/common';
import { CLMS  } from 'src/app/@framework/core/clms.fw.common';
import { Joove } from 'src/app/@framework/core/Joove';
import * as moment from 'moment';
import { TranslateService } from '@ngx-translate/core';
import { DataListColumnInfo, DataListColumnItemType, ListDynamicColumnValue } from '@framework/components/DataList/helpers/List.helper.classes';
import { ValueFormat } from '@framework/core/clms.fw.angular';
var numeral = require('numeral');
const VerEx = require('verbal-expressions');


export class InvoiceTemplate  {
    _originalTypeClassName = "zERP.BO.InvoiceTemplate";
constructor(protected translateService: TranslateService = null) {
if (translateService != null) {
InvoiceTemplate.translate = translateService;
}
this.Lines = [];
this.Variables = [];
this.Id = null;
this.Name = null;
this.Description = null;
this.TransactionType = null;
this.ExpenseSeries = null;
this.AutoPay = false;
this.IsTransformation = false;
this._key = this.Id = 0; 
}

static translate: TranslateService;
_key: any;
private _Id:any;
get Id(): any {
    return this._Id;
  }
set Id(value: any) {
    this._Id = value;
    this._key = value;
  }
Name:any;
Description:any;
TransactionType:any;
ExpenseSeries:any;
AutoPay:any;
IsTransformation:any;
TransactionEntity:any;
Lines:any;
InvoiceType:any;
BO:any;
Variables:any;
IssueDateBinding:any;
AccountingEvent:any;
PaymentMethod:any;
Series:any;
static setTransactionEntity = ($this, value) => {
var oldValue = $this.TransactionEntity;
$this.TransactionEntity = value;
if (value != null) {
}
}
static setLines = ($this, items) => {
                if (items == null) items = [];
                if ($this.Lines == null) $this.Lines = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Lines.length > 0) {
                    Domain.InvoiceTemplate.removeLines($this, $this.Lines[0]);
                }

                Domain.InvoiceTemplate.addManyLines($this, copyItems);
            }
static addManyLines = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTemplate.addLines($this, items[i]);
                }
            }
static addLines = ($this, item) => {
                if ($this.Lines == null) $this.Lines = [];
                if (item == null || $this.Lines.indexOf(item) > -1) return;
                $this.Lines.push(item);
}
static addRangeLines = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTemplate.addLines($this, item));
            }
static removeLines = ($this, item) => {
                if ($this == null || $this.Lines == null || $this.Lines.indexOf(item) === -1) return;
                var _index = $this.Lines.indexOf(item);
                $this.Lines.splice(_index, 1);
}
static clearLines = ($this) => { $this.Lines = null; }
static setInvoiceType = ($this, value) => {
var oldValue = $this.InvoiceType;
$this.InvoiceType = value;
if (value != null) {
}
}
static setBO = ($this, value) => {
var oldValue = $this.BO;
$this.BO = value;
if (value != null) {
}
}
static setVariables = ($this, items) => {
                if (items == null) items = [];
                if ($this.Variables == null) $this.Variables = [];

                const copyItems = Common.cloneObject(items);

                while ($this.Variables.length > 0) {
                    Domain.InvoiceTemplate.removeVariables($this, $this.Variables[0]);
                }

                Domain.InvoiceTemplate.addManyVariables($this, copyItems);
            }
static addManyVariables = ($this, items) => {
                if (items == null) return;
                for (let i = 0; i < items.length; i++) {
                    Domain.InvoiceTemplate.addVariables($this, items[i]);
                }
            }
static addVariables = ($this, item) => {
                if ($this.Variables == null) $this.Variables = [];
                if (item == null || $this.Variables.indexOf(item) > -1) return;
                $this.Variables.push(item);
}
static addRangeVariables = ($this, items: System.Collections.List<any>) => { 
                items.forEach(item => Domain.InvoiceTemplate.addVariables($this, item));
            }
static removeVariables = ($this, item) => {
                if ($this == null || $this.Variables == null || $this.Variables.indexOf(item) === -1) return;
                var _index = $this.Variables.indexOf(item);
                $this.Variables.splice(_index, 1);
}
static clearVariables = ($this) => { $this.Variables = null; }
static setIssueDateBinding = ($this, value) => {
var oldValue = $this.IssueDateBinding;
$this.IssueDateBinding = value;
if (value != null) {
}
}
static setAccountingEvent = ($this, value) => {
var oldValue = $this.AccountingEvent;
$this.AccountingEvent = value;
if (value != null) {
}
}
static setPaymentMethod = ($this, value) => {
var oldValue = $this.PaymentMethod;
$this.PaymentMethod = value;
if (value != null) {
}
}
static setSeries = ($this, value) => {
var oldValue = $this.Series;
$this.Series = value;
if (value != null) {
}
}


static IsNew($this: any): boolean {
                if ($this == null) return true;
                return $this.Id == null || $this.Id == 0;
            }


}